<script>
// CommitChart.js
import { Pie, mixins } from 'vue-chartjs'
const _ = require('lodash')
const { reactiveProp } = mixins
export default {
  extends: Pie,
  props: ['chart-option'],
  mixins: [reactiveProp],
  mounted () {
    var chartData = _.cloneDeep(this.chartData)
    this.renderChart(
      chartData,
      this.chartOption
    )
  }
}
</script>
